import React, { Component } from "react";
import PropTypes from 'prop-types';

import BusinessEditTab from "components/businesses/tabs/BusinessEditTab";
import BusinessApi from "apis/Business";
import { ROUTES } from "constants/Routes.js";

class BusinessTab extends Component {
  constructor() {
    super();
    this.state = {
      breadCrumbActiveTab: "",
      businessName: ""
    };
  }

  componentWillMount() {
    this.fetchBusinessName();
  }

  fetchBusinessName = () => {
    BusinessApi.getDetails(this.props.match.params.id).then(({ data }) =>
      this.setState({ businessName: data.name })
    );
  }

  render() {
    let businessId = this.props.match.params.id;
    let customSurveyId = this.props.match.params.customSurveyId;
    let currentUrl = this.props.match.path;
    return (
      <div>
        <BusinessEditTab
          businessId={businessId}
          customSurveyId={customSurveyId}
          currentUrl={currentUrl}
          businessName={this.state.businessName}
        />
      </div>
    );
  }
}

BusinessTab.propTypes = {
  match: PropTypes.object
};

export default BusinessTab;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/BusinessTab.js